export default __webpack_public_path__ + "static/media/1.043e48cb.jpg";